import _ from 'lodash'
import { SiteBookingUtils } from '@/common/tender/house/utils'

const validNumber = (value) => {
  return /^([1-9]\d+|\d)(\.\d{1,2})?$/.test(value)
}

const fn_compareNumber = (form, callback, [min, max], message) => {
  if ([form[min], form[max]].indexOf('') >= 0) callback()
  else if(form[max] - form[min] > 0) callback()
  else callback(new Error(message))
}

const fn_MARGIN_AMOUNT = (form, callback) => {
  if (!/^\d+\.\d{2}$/.test(form.CONTROL_PRICE)) {
    callback()
  } else if (form.MARGIN_AMOUNT - form.CONTROL_PRICE * 0.02 > 0) {
    callback(new Error('投标保证金提交的金额不能超过招标控制价的2%'))
  } else {
    callback()
  }
}

const fn_SITE_BOOKING_NUM = (form, callback) => {
  let value = form.SITE_BOOKING_NUM
  let reg_1 = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
  let reg_2 = /^[0-9a-f]{8}[0-9a-f]{4}[0-9a-f]{4}[0-9a-f]{4}[0-9a-f]{12}$/
  if(reg_1.test(value) || reg_2.test(value)) {
    SiteBookingUtils.remoteValid(form, callback)
  } else {
    callback(new Error('请填写有效的场地预约编号'))
  }
}

const fn_TENDERER_CODE = (form, callback) => {
  if(/^3502/.test(form.regionId)) {
    if(/^[a-zA-Z0-9]{18}$/.test(form.TENDERER_CODE)) {
      callback()
    } else {
      callback(new Error('请输入18位'))
    }
  } else {
    if(/^[a-zA-Z0-9]{1,18}$/.test(form.TENDERER_CODE)) {
      callback()
    } else {
      callback(new Error('请输入18位之内'))
    }
  }
}

const fn_TENDERER_NUM = ({ obj, args, value, callback, form }) => {
  let { TENDERER_NUM, ECONOMY_EXPERT_NUM } = form
  if(/^\d+$/.test(TENDERER_NUM) && /^\d+$/.test(ECONOMY_EXPERT_NUM)) {
    if(TENDERER_NUM * 2 - ECONOMY_EXPERT_NUM > 0) {
      callback(new Error('招标人代表不可超过评委总数的三分之一'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}

const fnZhTableData = ({ obj, args, value, callback, form, noisy }) => {
  const [ key1, key2, max ] = args
  const { index } = noisy
  const list = form[key1][index].data
  if (validNumber(value)) {
    const res = list.reduce((pre, cur) => pre && validNumber(cur[key2]), true)
    if (res) {
      const summary = list.reduce((pre, cur) => pre - -cur[key2], 0)
      if ((max[index] - summary).toFixed(4) - 0 === 0) {
        callback()
      } else {
        callback(new Error(`分值总和应为${max[index]}`))
      }
    } else {
      callback()
    }
  } else {
    callback(new Error('请填写数字'))
  }
}

const fnEvalScoreEpc = ({ obj, args, value, callback, form, noisy }) => {
  const [ key1, key2, maxKey, maxName ] = args
  const list = form[key1]
  const max = form[maxKey]
  if (key2 === 'POST_SCORE') {
    if (!validNumber(max)) {
      callback(new Error(`请先设置分值${maxName}`))
    } else if (validNumber(value)) {
      const res = list.reduce((pre, cur) => pre && validNumber(cur[key2]), true)
      if (res) {
        const summary = list.reduce((pre, cur) => pre - -cur[key2], 0)
        if (form.JS_EVAL_TYPE === '合格制' || (max - summary).toFixed(4) - 0 === 0) {
          callback()
        } else {
          callback(new Error(`分值总和应为${max}`))
        }
      } else {
        callback()
      }
    } else {
      callback(new Error('请填写数字'))
    }
  } else {
    if (validNumber(value)) {
      const res = list.reduce((pre, cur) => pre && validNumber(cur[key2]), true)
      if (res) {
        const summary = list.reduce((pre, cur) => pre - -cur[key2], 0)
        if ((1 - summary).toFixed(4) - 0 === 0) {
          callback()
        } else {
          callback(new Error('数字且权重累加为1'))
        }
      } else {
        callback()
      }
    } else {
      callback(new Error('请填写数字'))
    }
  }
}

export const houseRules = (obj, args, value, callback, form, noisy) => {
  let [type, ...params] = args
  switch (type) {
    case 'compareNumber':
      fn_compareNumber(form, callback, ...params)
      break;
    case 'MARGIN_AMOUNT':
      fn_MARGIN_AMOUNT(form, callback)
      break
    case 'SITE_BOOKING_NUM':
      fn_SITE_BOOKING_NUM(form, callback)
      break;
    case 'TENDERER_CODE':
      fn_TENDERER_CODE(form, callback)
      break;
    case 'TENDERER_NUM':
      fn_TENDERER_NUM({ obj, args, value, callback, form })
      break;
    case 'ZH_TABLE_DATA':
      fnZhTableData({ obj, args, value, callback, form, noisy })
      break;
    case 'EVAL_SCORE_FOR_SS':
      fnEvalScoreEpc({ obj, args, value, callback, form, noisy })
      break;
    case 'EVAL_SCORE_FOR_JY':
      fnEvalScoreEpc({ obj, args, value, callback, form, noisy })
      break;
  }
}

export default {}